import { useState } from "react";
import { LogoutOutlined } from "@mui/icons-material";
import { Button } from "@mui/material";

import { logout } from "../../../authentication/store/auth.slice";
import { useAppDispatch } from "../../../store";

/** Выход для страниц, где сессия EkoCrop есть, а работать в приложении нельзя. */
export const SignOutButton = (): JSX.Element => {
  const dispatch = useAppDispatch();
  const [isSigningOut, setSigningOut] = useState(false);

  const handleClick = () => {
    setSigningOut(true);
    dispatch(logout());
  };

  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={<LogoutOutlined />}
      disabled={isSigningOut}
      onClick={handleClick}
    >
      Выйти
    </Button>
  );
};
